import AppDispatcher from '../dispatcher/AppDispatcher';
import * as AppConstants from '../utility/constants';

let AppActions = {

	changeAmount: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_AMOUNT,
			item: item
		})
	},

	changeSymbol: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_SYMBOL,
			item: item
		})
	},

	changeCode: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_CODE,
			item: item
		})
	},

	changeFormatedAmount: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_FORMATED_AMOUNT,
			item: item
		})
	},

	changeRecurring: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_RECURRING,
			item: item
		})
	},

	changeRecurringModalStatus: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.RP_MODAL_CLOSED,
			item: item
		})
	},

	changeNote: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_NOTE,
			item: item
		})
	},

	changeCountry: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CHANGE_COUNTRY,
			item: item
		})
	},

	updateConfirmation: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.UPDATE_CONFIRMATION,
			item: item
		})
	},

	updatePostBackData: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.POST_BACK_DATA,
			item: item
		})
	},

	updateCurrentPage: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.UPDATE_CURRENT_PAGE,
			item: item
		})
	},

	updateServerErrors: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.UPDATE_SERVER_ERRORS,
			item: item
		})
	},

	updatePaymentError: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.PAYMENT_ERROR,
			item: item
		})
	},

	updateSignUpError: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.UPDATE_SIGN_UP_ERROR,
			item: item
		})
	},

	updateFundingOptions: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.FUNDING_OPTIONS,
			item: item
		})
	},

	updateEmail: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.EMAIL,
			item: item
		})
	},

	updateBillingAddress: (item) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.BILLING_ADDRESS,
			item: item
		})
	},

	/**
	 * Sets the donation amount type
	 * @param  {String} type type of donation amount - "preset" or "userinput"
	 */
	updateDonationAmountType: (donationAmountType) => {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.UPDATE_DONATION_AMOUNT_TYPE,
			item: donationAmountType
		})
	},
	
}

module.exports = AppActions



// WEBPACK FOOTER //
// ./actions/AppActions.js